import { jsonMember, jsonObject } from 'typedjson';

@jsonObject
export class RefundSummaryResponse {
  @jsonMember(Number)
  public readonly originalPrice!: number;

  @jsonMember(Number)
  public readonly refundedPrice!: number;

  @jsonMember(Number)
  public readonly currentPrice!: number;
}
